export function checkShowConditions(settings, surveyId, storage) {
    let completedSurveys = storage.get('ph_survey_completed') || [];
    let viewedSurveys = storage.get('ph_survey_viewed') || [];
    let hasAtLeastOneAnswerSurveys = storage.get('ph_survey_at_least_one_answer') || [];

    switch (settings.visibility) {
        case 'untilSubmitted':
            return !completedSurveys.includes(surveyId);
        case 'always':
            return true;
        case 'once':
            return !viewedSurveys.includes(surveyId);
        case 'atLeastOneAnswer':
            return !hasAtLeastOneAnswerSurveys.includes(surveyId);
        default:
            return true;
    }
}

// Sampling must be stable per user: instead of rolling the dice on every page
// view, a hash of user id + survey id yields a fixed bucket in [0, 100). A user
// therefore sees a sampled survey either on every page or on none, even after
// the local storage was cleared.
export function getSurveyDisplayDecision(survey, storage) {
    const proportionOfUsers = normalizeProbability(survey.survey_settings?.proportionOfUsers ?? 100);
    const userId = (storage && storage.get('ph_user_id')) || '';

    return shouldShowSurvey(proportionOfUsers, `${userId}:${survey.survey_id}`);
}

function normalizeProbability(val) {
    if (typeof val === 'string') {
        val = val.trim().replace(',', '.');
    }
    val = parseFloat(val);
    if (isNaN(val) || val < 0 || val > 100) return 100;
    return val;
}

// 32-bit FNV-1a; small, dependency free and identical on every device
export function hashString(str) {
    let hash = 0x811c9dc5;
    for (let i = 0; i < str.length; i++) {
        hash ^= str.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193) >>> 0;
    }
    return hash >>> 0;
}

// Maps a seed to a bucket in [0, 100) with two decimals of resolution so
// fractional proportions (e.g. 12.5 %) sample correctly.
export function seedToPercent(seed) {
    return (hashString(String(seed)) % 10000) / 100;
}

export function shouldShowSurvey(proportion, seed) {
    if (proportion >= 100) return true;
    if (proportion <= 0) return false;
    return seedToPercent(seed) < proportion;
}

// A survey may only be displayed when it is switched on and not paused.
// Config values arrive either as booleans or as "0"/"1" strings.
export function isSurveyActive(survey) {
    if (!survey) return false;
    const active = survey.active === true || survey.active === '1';
    const paused = !(survey.isPaused === false || survey.isPaused === '0');
    return active && !paused;
}
